import React, { useState } from 'react';
import {
    Box,
    Grid,
    TextField,
    Typography,
    Button,
    Card,
    CardContent,
    IconButton,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

function Unemployment({ onNext }) {
    const [periods, setPeriods] = useState([{
        startDate: null,
        endDate: null,
        reason: '',
    }]);

    const handleChange = (index) => (field) => (event) => {
        const newPeriods = [...periods];
        newPeriods[index] = {
            ...newPeriods[index],
            [field]: event.target.value
        };
        setPeriods(newPeriods);
    };

    const handleDateChange = (index, field) => (date) => {
        const newPeriods = [...periods];
        newPeriods[index] = {
            ...newPeriods[index],
            [field]: date
        };
        setPeriods(newPeriods);
    };

    const addPeriod = () => {
        setPeriods([...periods, {
            startDate: null,
            endDate: null,
            reason: '',
        }]);
    };

    const removePeriod = (index) => {
        if (periods.length > 1) {
            setPeriods(periods.filter((_, i) => i !== index));
        }
    };

    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', p: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6">Unemployment Periods</Typography>
                <Button
                    variant="outlined"
                    onClick={addPeriod}
                    startIcon={<AddIcon />}
                >
                    Add Period
                </Button>
            </Box>

            {periods.map((period, index) => (
                <Card variant="outlined" sx={{ mb: 3 }} key={index}>
                    <CardContent>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                            <Typography variant="subtitle1">Period {index + 1}</Typography>
                            {periods.length > 1 && (
                                <IconButton onClick={() => removePeriod(index)} size="small">
                                    <DeleteIcon />
                                </IconButton>
                            )}
                        </Box>

                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label="Start Date"
                                        value={period.startDate}
                                        onChange={handleDateChange(index, 'startDate')}
                                        renderInput={(params) => <TextField {...params} fullWidth required />}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label="End Date"
                                        value={period.endDate}
                                        onChange={handleDateChange(index, 'endDate')}
                                        renderInput={(params) => <TextField {...params} fullWidth />}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={3}
                                    label="Reason"
                                    value={period.reason}
                                    onChange={handleChange(index)('reason')}
                                    required
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            ))}

            <Box sx={{ mt: 3 }}>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={onNext}
                >
                    Continue
                </Button>
            </Box>
        </Box>
    );
}

export default Unemployment;
